// The desktop's own box, once the CRT shell is around it. Windows read this instead of window.inner*
// so a maximized window fills the SCREEN, not the monitor. One module-level value + a subscription,
// because it changes only when the frame is toggled or the viewport crosses the phone breakpoint.
import { useEffect, useState } from 'react';

export const FRAME = { x: 16, top: 16, bottom: 58 }; // side/top bezel, and the chin
export const MIN_WIDTH = 900; // phones get no monitor around them
const KEY = 'ic:bezel';
const ZERO = { x: 0, top: 0, bottom: 0 };

const listeners = new Set();
let on = (() => {
  try {
    return localStorage.getItem(KEY) !== '0';
  } catch (e) {
    return true; // private mode
  }
})();

export const bezelOn = () => on && window.innerWidth >= MIN_WIDTH;
export const currentInset = () => (bezelOn() ? FRAME : ZERO);
export function setBezel(next) {
  on = !!next;
  try {
    localStorage.setItem(KEY, on ? '1' : '0');
  } catch (e) {
    /* private mode */
  }
  listeners.forEach(fn => fn());
}
export const toggleBezel = () => setBezel(!on);
export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
// resizing can cross the phone breakpoint, which changes the inset without any toggle
if (typeof window !== 'undefined') {
  window.addEventListener('resize', () => listeners.forEach(fn => fn()));
}

export function useBezelInset() {
  const [inset, setInset] = useState(currentInset);
  useEffect(() => subscribe(() => setInset(currentInset())), []);
  return inset;
}
